<div
  class="hss-container"
  [ngStyle]="{ 'font-size': fontSize().toFixed(1) + 'px' }"
>
  @if (hss) {
    <app-header
      [hss]=hss
      [index]=index
      [enhanced]=enhanced  
    ></app-header>

    <!-- Column names -->
    <pre class="hss-row" [class.e-label]="enhanced">
    DT EQ  FLT STA DEP  M STA ARR  AC FLY    GTR  GRD     ACT</pre
    >

    @for (dp of hss.dutyPeriods; track dp.index) {
      @for (leg of hss.legs; track leg.index) {
        @if (
          leg.index &&
          leg.dpIndex === dp.index &&
          (leg.isActive.text === "True" || leg.isCancelled.text === "True")
        ) {
          <!-- SKD Row -->
          <!-- SPT used to identifiy split duty rest which is handled different -->
          @if (leg.oalSurfaceAirline.text === "SPT") {
            <app-split-duty-rest
              [hss]="hss"
              [leg]="leg"
              [enhanced]="enhanced"
              [index]="index"
            ></app-split-duty-rest>
          }
          @else {
            <app-skd-row
              [hss]="hss"
              [leg]="leg"
              [enhanced]="enhanced"
              [index]="index"
            ></app-skd-row>
          }

          <!-- RSK Row -->
          @if (leg.oalSurfaceAirline.text !== "SPT" && hssBuilderService.shouldShowRsk(leg)) {
            <app-reskd-row
              [hss]="hss"
              [leg]="leg"
              [enhanced]="enhanced"
              [index]="index"
            ></app-reskd-row>
          }

          <!-- ACT Row -->
          @if (
            leg.oalSurfaceAirline.text !== "SPT" &&
            (leg.isDepTimeActual.text === "True" ||
            leg.isCancelled.text === "True")
          ) {
            <app-act-row
              [hss]="hss"
              [leg]="leg"
              [enhanced]="enhanced"
              [index]="index"
            ></app-act-row>
          }
          @if (leg.oalSurfaceAirline.text === "SPT" && leg.isDepTimeActual.text === "True") {
            <!-- Actual row for split-duty rest AKA FAA (REST  FAA) -->
            <app-split-duty-rest
              [hss]="hss"
              [leg]="leg"
              [enhanced]="enhanced"
              [index]="index"
              [isAct]=true
            ></app-split-duty-rest>
            <!-- "CBA" row always accompanies "FAA" row -->
            <app-split-duty-rest
              [hss]="hss"
              [leg]="leg"
              [enhanced]="enhanced"
              [index]="index"
              [isCba]=true
            ></app-split-duty-rest>
          }
        }
      }

      <!-- Duty period summary -->
      @if (hssBuilderService.getActiveLegs(hss, dp.index) > 0) {
        @if (hssBuilderService.getDpState(hss, dp.index); as dpState) {
          <app-dp-summary
            [hss]="hss"
            [dp]="dp"
            [stationTimeZones]="stationTimeZones"
            [dpState]="dpState"
            [raps]="raps"
            [enhanced]="enhanced"
            [index]="index"
          ></app-dp-summary>
        }
      }
    }

    <!-- Sequence summary -->
    <app-seq-summary
      [hss]="hss"
      [enhanced]="enhanced"
      [index]="index"
    ></app-seq-summary>
  }
</div>
